import { useRef } from 'react';

import { cn, useIsClamped } from '@crm/shared/lib';

import { ColumnDropdownMenu } from './ColumnDropdownMenu';

interface IColumnHeaderProps {
    isDefault: boolean;
    isDragging: boolean;
    headerText: string;
    visibleColumnColor: string;
    handleRef?: (element: Element | null) => void;
    onDelete: () => void;
    onEditMode: () => void;
}

export const ColumnHeader = ({
    isDefault,
    isDragging,
    headerText,
    visibleColumnColor,
    handleRef,
    onDelete,
    onEditMode,
}: IColumnHeaderProps) => {
    const titleRef = useRef<HTMLHeadingElement>(null);
    const isTitleClamped = useIsClamped(titleRef);

    return (
        <div className="flex w-full shrink-0 flex-col gap-2.5 px-2 py-0.5">
            <div className="flex items-center justify-between gap-2">
                <div
                    ref={isDefault ? undefined : handleRef}
                    className={cn(
                        'flex min-w-0 flex-1 items-center gap-1.5',
                        !isDefault && 'cursor-grab',
                        isDragging && 'cursor-grabbing'
                    )}
                >
                    <span
                        className="h-2 w-2 shrink-0 rounded-full"
                        style={{ backgroundColor: visibleColumnColor }}
                    />
                    <h3
                        ref={titleRef}
                        className="truncate text-base font-bold"
                        title={isTitleClamped ? headerText : undefined}
                    >
                        {headerText}
                    </h3>
                </div>
                {!isDefault && <ColumnDropdownMenu onEditMode={onEditMode} onDelete={onDelete} />}
            </div>
        </div>
    );
};
